<template>
  <v-menu
    offset-y
    :nudge-bottom="10"
    transition="slide-y-transition"
    eager
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        large
        text
        v-on="on"
        v-bind="attrs"
      >
        <InitialsIcon
          size="40px"
          :given-name="givenName"
          :surname="surname"
        />
      </v-btn>
    </template>

    <v-card
      class="mx-auto"
      max-width="352"
    >
      <v-list
        two-line
        class="pa-3 pl-0"
      >
        <v-list-item class="pl-6">
          <InitialsIcon
            size="40px"
            :given-name="givenName"
            :surname="surname"
          />

          <div class="ml-4">
            <v-list-item-subtitle class="profile-title-font">
              {{ givenName || "Unknown" }} {{ surname || "User" }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="profile-subtitle-font">
              {{ jobTitle || "None" }}
            </v-list-item-subtitle>
          </div>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list-item-group>
        <v-list-item
          class="pl-8"
          @click="updateProfileHandler"
          v-if="updateProfile"
        >
          <v-list-item-icon>
            <v-icon>mdi-pencil-outline</v-icon>
          </v-list-item-icon>
          <div>
            <v-list-item-title class="profile-title-font">
              Update profile
            </v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item
          class="pl-8"
          @click="changePasswordHandler"
          v-if="changePassword"
        >
          <v-list-item-icon>
            <v-icon>mdi-lock-outline</v-icon>
          </v-list-item-icon>
          <div>
            <v-list-item-title class="profile-title-font">
              Change password
            </v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item
          class="pl-8"
          @click="updateSecretQuestionHandler"
          v-if="updateSecretQuestion"
        >
          <v-list-item-icon>
            <v-icon>mdi-security</v-icon>
          </v-list-item-icon>
          <div>
            <v-list-item-title class="profile-title-font">
              Update secret questions
            </v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item
          class="pl-8"
          @click="portalSettingsHandler"
          v-if="portalSettings"
        >
          <v-list-item-icon>
            <v-icon>mdi-cog-outline</v-icon>
          </v-list-item-icon>
          <div>
            <v-list-item-title class="profile-title-font">
              Portal settings
            </v-list-item-title>
          </div>
        </v-list-item>

        <v-divider />

        <v-list-item
          class="pl-8"
          @click="logoutHandler"
          v-if="logoutHandler"
        >
          <v-list-item-icon>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <div>
            <v-list-item-title class="profile-title-font">
              Log out
            </v-list-item-title>
          </div>
        </v-list-item>
      </v-list-item-group>
    </v-card>
  </v-menu>
</template>

<script>
  import InitialsIcon from '../InitialsIcon';

  export default {
    name: "Profile",
    components: {
      InitialsIcon
    },
    props: {
      givenName: {
        type: String,
        default: '',
      },
      surname: {
        type: String,
        default: '',
      },
      jobTitle: {
        type: String,
        default: '',
      },
      updateProfile: {
        type: Boolean,
        default: true,
      },
      changePassword: {
        type: Boolean,
        default: true,
      },
      updateSecretQuestion: {
        type: Boolean,
        default: true,
      },
      portalSettings: {
        type: Boolean,
        default: true,
      },
      logout: {
        type: Boolean,
        default: true,
      },
      updateProfileHandler: {
        type: Function,
        default: () => {
        },
      },
      changePasswordHandler: {
        type: Function,
        default: () => {
        },
      },
      updateSecretQuestionHandler: {
        type: Function,
        default: () => {
        },
      },
      portalSettingsHandler: {
        type: Function,
        default: () => {
        },
      },
      logoutHandler: {
        type: Function,
        default: () => {
        },
      },
    },
  }
</script>

<style scoped>
  .profile-title-font {
    color: #041E42 !important;
    font-size: 16px !important;
    line-height: 24px !important;
  }

  .profile-subtitle-font {
    color: #666666 !important;
    font-size: 14px !important;
    line-height: 21px !important;
  }

  /*force width to avoid jank in IE11*/
  .v-list-item__icon .v-icon {
    width: 24px;
    color: #041E42;
  }
</style>
